import { render } from "./users.vue?vue&type=template&id=220c4604&scoped=true"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import "./users.vue?vue&type=style&index=0&id=220c4604&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-220c4604"

export default script